// Small, always-needed bits of this page (path, title, dates), kept apart from the
// page text so the main app bundle does not have to carry the whole page.
export const AI_COMPANION_PATH = '/ai-companion';

export const AI_COMPANION_META = {
  title: 'Zuzu Club AI Companion | An AI to Talk To or Practice Listening',
  description: 'Talk to the Zuzu AI Companion anytime, or practice being a better listener as it plays someone who needs to talk. Clearly AI, never therapy. Free, no signup.',
  image: 'https://www.zuzu.club/og/zuzu-club-ai-companion.jpg?v=10',
  alt: 'Zuzu AI Companion: someone to talk to, anytime. It listens, or lets you practice listening. Clearly AI, never therapy.',
};
